// 汎用エラーページ
import UtilityError from '@/components/UtilityError'
// ルートページ
import RootPage from '@/components/RootPage'

export default [
		{
			path: '/UtilityError',
			name: 'UtilityError',
			component: UtilityError
		},
		// ルートページ（リダイレクトするだけ）
		{
			path: '*',
			name: 'RootPage',
			component: RootPage
		},
]






// WEBPACK FOOTER //
// ./src/router/routes.js